import {EmployeeActionBarVI} from "./employee/vi";
import {ApplicationActionBarVI} from "./application/vi";
import {DecisionActionBarVI} from "./decision/vi";
import {KpiActionBarVI} from "./kpi/vi";
import {EmployeeContractActionBarVI} from "./contract/vi";
import {AssessmentActionBarVI} from "./assessment/vi";

export const ActionBarVI = {
    ...EmployeeActionBarVI,
    ...ApplicationActionBarVI,
    ...DecisionActionBarVI,
    ...KpiActionBarVI,
    ...EmployeeContractActionBarVI,
    ...AssessmentActionBarVI
}